import { useState } from 'react';
import { makeApiRequest, RequestStatus } from '../../api_request/api_request';
import { useAppDispatch } from '../../store/hooks';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { GetPageTitle } from '../../ErnotsConfig';

export function PasswordResetRequest()
{
    const appDispatch = useAppDispatch();
    
    const [email, setEmail] = useState('');
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>)
    {
        e.preventDefault();

        const userData = {email};
        makeApiRequest({
            endpoint: 'reset_password/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequest,
            useAuthPrefix: true
        });
    }

    const ret = (
        <div>
            <h2>Request password reset</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="email">Enter your email address:</label>
                    <Input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <Valid bValid={email.trim()} children='An email address is required.'/>
                </div>
                <Button type='submit'>Send Password Reset Link</Button>
            </form>
            <RequestStatusDisplay request={request}/>
        </div>
    );

    return (
    <div className='ernots_User ernots_PasswordResetRequest'>
        <title>{GetPageTitle('Password Reset Request')}</title>
        {ret}
    </div>);
};